import { useState, useCallback, useEffect } from "react";
import { POComment } from "@po-management/types";
import { useApiClient } from "../../auth/useApiClient";

export function useComments(poId: string): {
  comments: POComment[];
  loading: boolean;
  error: string | null;
  addComment: (message: string) => Promise<boolean>;
} {
  const { get, post } = useApiClient();
  const [comments, setComments] = useState<POComment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    get(`/api/pos/${poId}/comments`)
      .then((r) => r.json() as Promise<{ success: boolean; data: POComment[] }>)
      .then((body) => { if (body.success) setComments(body.data); })
      .catch(() => setError("Failed to load comments"))
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poId]);

  const addComment = useCallback(async (message: string): Promise<boolean> => {
    try {
      const res = await post(`/api/pos/${poId}/comments`, { message });
      const body = await res.json() as { success: boolean; data: POComment };
      if (!res.ok || !body.success) return false;
      setComments((prev) => [...prev, body.data]);
      return true;
    } catch {
      return false;
    }
  }, [poId, post]);

  return { comments, loading, error, addComment };
}
